import React from 'react';
import {Redirect} from 'react-router';

import withStyles from "@material-ui/core/styles/withStyles";

import api from "../../../api/Api";
import {NavLink} from "react-router-dom";

// @material-ui/core components
import FormLabel from "@material-ui/core/FormLabel";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber,
    verifyPhoneNumber, dashboardRouter
} from '../../../util/globalHelper'

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";


class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            email: "",
            emailState: "",
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            contactNumber: "",
            contactNumberState: "",
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            validation: null
        };
        this.typeClick = this.typeClick.bind(this);
    }

    componentWillMount() {

    }

    change(event, stateName, type, stateNameEqualTo, maxValue) {
        this.setState({[stateName]: event.target.value});
        if (stateName === "username" && event.target.value.length > 3 && this.state.usernameState === "success") {
            api.validateUser({"username": event.target.value}).then(json => {
                this.setState({validation: json.data.data.valid})
            })
        }
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                }
                else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            default:
                break;
        }
    }

    CallCreateApi(data) {
        api.createClinicMaster(data)
            .then(json => {
                if (json.data.isError === false && json.data.data._id) {
                    var msgcolor = {message: "ClinicMaster Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/clinicmaster/oneClinicMaster/${json.data.data._id}`))
                } else {
                    var msgcolor = {message: json.data.reason, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                }
            }).catch(error => {
            var msgcolor = {message: "Server Error!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        })
    }

    typeClick() {
        if (this.state.nameState === "") {
            this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please fill the name!", color: "danger"});

        }
        else if (this.state.usernameState === "") {
            this.setState({usernameState: "error"});
            this.props.id.generateNotification({message: "Please fill the username!", color: "danger"});

        }
        else if (this.state.emailState === "") {
            this.setState({emailState: "error"});
            this.props.id.generateNotification({message: "Please fill the email!", color: "danger"});

        }
        else if (this.state.contactNumberState === "") {
            this.setState({contactNumberState: "error"});
            this.props.id.generateNotification({message: "Please fill the number!", color: "danger"});

        }
        else if (this.state.clinicnameState === "") {
            this.setState({clinicnameState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic name!", color: "danger"});

        }
        else if (this.state.nameState === "success" && this.state.usernameState === "success" && this.state.contactNumberState === "success" && this.state.emailState === "success" && this.state.clinicnameState === "success") {
            var data = {
                name: this.state.name,
                // last_name: this.state.last_name,
                username: this.state.username,
                email: this.state.email,
                contact: this.state.contactNumber,
                password: this.state.password,
                is_doctor: false,
                clinic_name: this.state.clinicname,
                company_number: this.state.companyNumber,
                // admin_name: this.state.adminName,
                // contact_info: this.state.contactNumber
            }
            this.CallCreateApi(data);
        }
        else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <div>
                {this.state.alert}
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <h4 className={classes.cardTitle}>New Clinic Master</h4>
                                </CardText>
                            </CardHeader>
                            <CardBody>
                                <form>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Clinic Name *
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.clinicnameState === "success"}
                                                error={this.state.clinicnameState === "error"}
                                                id="clinicname"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "clinicname", "name")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Username *
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.usernameState === "success"}
                                                error={this.state.usernameState === "error"}
                                                id="username"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "username", "alphanum")
                                                }}
                                            />
                                            <small>{this.state.validation === true ? "Username available" : this.state.validation === false ? "Username not avalibale" : null}</small>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Password *
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.passwordState === "success"}
                                                error={this.state.passwordState === "error"}
                                                id="password"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "password", "alphanum"),
                                                    type: "password"

                                                }}

                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Name *
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.nameState === "success"}
                                                error={this.state.nameState === "error"}
                                                id="name"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "name", "name")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Contact Number *
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.contactNumberState === "success"}
                                                error={this.state.contactNumberState === "error"}
                                                id="url"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event => this.change(event, "contactNumber", "phonenumber")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Email *
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.emailState === "success"}
                                                error={this.state.emailState === "error"}
                                                id="email"
                                                formControlProps={{
                                                    fullWidth: true,
                                                    required: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "email", "email")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>

                                    <GridContainer>

                                        <GridItem xs={12} sm={2}>
                                            <FormLabel className={classes.labelHorizontal}>
                                                Company Number
                                            </FormLabel>
                                        </GridItem>
                                        <GridItem xs={12} sm={8}>
                                            <CustomInput
                                                success={this.state.companyNumberState === "success"}
                                                error={this.state.companyNumberState === "error"}
                                                id="companynumber"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    onChange: event =>
                                                        this.change(event, "companyNumber", "alphanum")
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </form>
                            </CardBody>
                            <CardFooter>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={3}>
                                        <Button block size="lg" color="warning" onClick={this.typeClick}>
                                            Add
                                        </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={3}>
                                        <NavLink to={dashboardRouter(`/clinicmaster/readClinicMasters`)}>
                                            <Button block size="lg" color="grey">
                                                Cancel
                                            </Button>
                                        </NavLink>
                                    </GridItem>
                                </GridContainer>
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }

}

export default withStyles(validationFormsStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/ClinicMasterForm/ClinicMasterForm.jsx